import { all, call, put, select, take, takeLatest } from 'redux-saga/effects';
import { EnvironmentState } from 'vrlcm-gui-types';
import {
  requestActionsSuccess,
  requestMapData,
  requestMapDataFailed,
  requestMapDataSuccess
} from '../actions/Dashboard';
import {
  pollEnvironmentsStart,
  PollEnvironmentsSuccess
} from '../actions/Environments';
import DashboardAPI from '../api/Dashboard';
import * as Constants from '../constants/action-constants';
import { PRODUCT_MAPPING } from '../constants/AppConstants';
import { ROUTES } from '../constants/RouteConstants';
import { StoreState } from '../types';
import { MapMarker } from '../types/Dashboard';

function* getQuickActions() {
  const actions = yield call(DashboardAPI.getQuickActions);
  yield put(requestActionsSuccess(actions));
}

function* watchForQuickActions() {
  yield takeLatest(Constants.REQUEST_ACTIONS, getQuickActions);
}

function* getDashboardData() {
  yield put(pollEnvironmentsStart({ fetchMapData: true }));
  yield put(requestMapData());
}

function* watchForDashboardData() {
  yield takeLatest(Constants.REQUEST_DASHBOARD_DATA, getDashboardData);
}

const getEnvironmentsFromState = (state: StoreState) =>
  state.environments.items.completed;

function* getMapData() {
  try {
    const markers: MapMarker[] = yield call(DashboardAPI.getMapData);
    const environments: EnvironmentState[] = yield select(
      getEnvironmentsFromState
    );
    const mapData = markers.map(marker => {
      return {
        ...marker,
        children: marker.children.map(datacenter => {
          return {
            ...datacenter,
            children: environments
              .filter(
                environment =>
                  environment.environmentRequestDTO.infrastructure.properties
                    .dataCenterVmid === datacenter.id
              )
              .map(environment => {
                const {
                  environmentId,
                  environmentName,
                  products
                } = environment.environmentRequestDTO;
                return {
                  id: environmentId,
                  name: environmentName,
                  icon: 'environment-ico',
                  action: `${ROUTES.ENVIRONMENTS}/${environmentId}`,
                  children: products.map(product => {
                    return {
                      id: `${environmentId}-${product.id}`,
                      name: PRODUCT_MAPPING[product.id],
                      icon: `${product.id}-ico`,
                      action: `${ROUTES.ENVIRONMENTS}/${environmentId}?product=${product.id}`,
                      children: product.nodes.map(node => {
                        return {
                          id: `${environmentId}-${product.id}-${node.type}`,
                          name: node.type,
                          action: `${ROUTES.ENVIRONMENTS}/${environmentId}?product=${product.id}`,
                          icon: `${product.id}-ico`,
                          children: null
                        };
                      })
                    };
                  })
                };
              })
          };
        })
      };
    });
    yield put(requestMapDataSuccess(mapData));
  } catch (error) {
    yield put(requestMapDataFailed());
  }
}

function* watchForMapData() {
  while (true) {
    const action: PollEnvironmentsSuccess = yield take(
      Constants.POLL_ENVIRONMENTS_SUCCESS
    );
    if (action.payload.fetchMapData) {
      yield call(getMapData);
    }
  }
}

export default function* dashboardSaga() {
  yield all([
    watchForQuickActions(),
    watchForDashboardData(),
    watchForMapData()
  ]);
}
